import { ToggleButtonGroup } from '@tailwindComponents/ToggleButtonGroup';
import { SkuViewMode } from './SkuToolbar';

export type ProductHierarchyLevel = 'products' | 'skus';

export interface ProductHierarchyToggleProps {
  view: SkuViewMode;
  onViewChange: (view: SkuViewMode) => void;
}

export function hierarchyLevelOfView(view: SkuViewMode): ProductHierarchyLevel {
  return view === 'products' ? 'products' : 'skus';
}

export function ProductHierarchyToggle({
  view,
  onViewChange,
}: ProductHierarchyToggleProps) {
  return (
    <ToggleButtonGroup
      label='View by'
      options={[
        { value: 'products', label: 'Product' },
        { value: 'skus', label: 'SKU' },
      ]}
      selected={hierarchyLevelOfView(view)}
      onChange={(level) =>
        onViewChange(level === 'products' ? 'products' : 'list')
      }
    />
  );
}
